// Single-page (questionnaire-table) welcome tour. Each step is anchored to a
// CSS selector or rendered as a centred modal (when `target` is omitted).

/**
 * @typedef {Object} TourStep
 * @property {string} [target] - CSS selector for the highlighted element. Omit for a centred modal.
 * @property {string} title
 * @property {string} body
 * @property {'top'|'bottom'|'left'|'right'|'over'} [side]
 * @property {'start'|'center'|'end'} [align]
 */

/** @type {TourStep[]} */
export const TOUR_STEPS = [
    {
        title: 'Welcome to ISOQAR Questionnaires',
        body: "Let's take a quick tour. It'll only take a minute, and you can skip at any point.",
    },
    {
        target: '[data-tour="questionnaire-tabs"]',
        title: 'My Questionnaires & Shared',
        body: 'Switch between questionnaires you own and those shared with you.',
        side: 'bottom',
        align: 'start',
    },
    {
        target: '[data-tour="questionnaire-search"]',
        title: 'Search',
        body: 'Quickly find a questionnaire by name, standard, or status.',
        side: 'bottom',
        align: 'end',
    },
    {
        target: '[data-tour="questionnaire-actions"]',
        title: 'Actions & Settings',
        body: 'Clone, share, or export questionnaires. Click the settings cog to log out or access other options.',
        side: 'bottom',
        align: 'end',
    },
    {
        target: '[data-tour="questionnaire-new"]',
        title: 'Create New',
        body: 'Start a brand new questionnaire from here.',
        side: 'bottom',
        align: 'end',
    },
    {
        target: '[data-tour="questionnaire-table"]',
        title: 'Your Questionnaires',
        body: 'All your questionnaires are listed here. Click "Continue" to resume or "View" to review a completed one.',
        side: 'top',
        align: 'center',
    },
    {
        title: 'All done!',
        body: "You're all set. You can replay this tour at any time from the settings screen.",
    },
];
